import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enterprise-manager',
  templateUrl: './enterprise-manager.component.html',
  styleUrls: ['./enterprise-manager.component.css']
})
export class EnterpriseManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
